import React from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import jobsRoutes from './jobsPublic/jobsRoutes'

const router = createBrowserRouter(jobsRoutes)

const domNode = document.getElementById('job4u-jobs-public')

if (domNode) {
    createRoot(domNode).render(<RouterProvider router={router} />)
}
